import { useRef } from "react";
import "../../../pages/public/PublicHome.css";
import usePlatformInteractions from "../hooks/usePlatformInteractions";
import PlatformHeader from "../components/platform/PlatformHeader";
import PlatformHero from "../components/platform/PlatformHero";
import PlatformOverview from "../components/platform/PlatformOverview";
import PlatformOperations from "../components/platform/PlatformOperations";
import PlatformExperience from "../components/platform/PlatformExperience";
import PlatformBusinessApps from "../components/platform/PlatformBusinessApps";
import PlatformPricing from "../components/platform/PlatformPricing";
import PlatformContact from "../components/platform/PlatformContact";
import PlatformFooter from "../components/platform/PlatformFooter";

export default function PublicHome() {
  const rootRef = useRef(null);
  usePlatformInteractions(rootRef);
  return <div className="onestack-page page-shell" ref={rootRef}>
    <PlatformHeader />
    <main>
      <PlatformHero />
      <PlatformOverview />
      <PlatformOperations />
      <PlatformExperience />
      <PlatformBusinessApps />
      <PlatformPricing />
      <PlatformContact />
    </main>
    <PlatformFooter />
  </div>;
}
